<template>
  <div>
    <b-alert show variant="danger">
      <b>Er is iets fout gegaan:</b>
      <ul>
        <li v-for="error in errors">
          <template v-if="!i18n">
            {{ error }}
          </template>
          <template v-if="i18n">
            {{ $t(error.text) }}
          </template>
        </li>
      </ul>
    </b-alert>
  </div>
</template>
<script>
export default {
  props: {
    errors: {
      type: Array,
      default: [],
    },
    i18n: {
      type: Boolean,
      default: false,
    },
  },
  name: 'ErrorBox'
}
</script>

